import React from 'react';

export default function Modal({ open, onClose, onBack, title, children }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6">
      <div className="absolute inset-0 bg-black/30 backdrop-blur-sm" onClick={onClose} />
      <div
        className="relative z-10 bg-gradient-to-br from-slate-800/98 via-slate-900/98 to-black/98 backdrop-blur-xl rounded-xl sm:rounded-2xl shadow-2xl flex flex-col w-full max-w-[95vw] sm:max-w-4xl max-h-[95vh] sm:max-h-[85vh] min-h-[300px] sm:min-h-[600px] border border-white/10 overflow-hidden"
        style={{
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.9), 0 0 0 1px rgba(255, 255, 255, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.1)'
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div className="relative bg-gradient-to-r from-slate-800/50 to-slate-700/50 backdrop-blur-sm">
          <div className="flex items-center justify-between p-3 sm:p-6">
            {onBack && (
              <button
                onClick={onBack}
                className="flex items-center justify-center px-4 py-2 sm:px-6 sm:py-3 rounded-xl bg-gradient-to-br from-blue-500/20 to-blue-600/30 hover:from-blue-500/30 hover:to-blue-600/40 border border-blue-400/40 hover:border-blue-400/60 transition-all duration-200 group shadow-lg hover:shadow-blue-500/20 min-w-[80px] sm:min-w-[100px]"
                aria-label="Vissza"
                type="button"
                title="Vissza"
              >
                <div className="flex items-center space-x-2">
                  <svg className="w-4 h-4 text-blue-300 group-hover:text-blue-200 group-hover:scale-110 transition-all" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2.5}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                  </svg>
                  <span className="text-xs font-bold text-blue-300 group-hover:text-blue-200">VISSZA</span>
                </div>
              </button>
            )}
            
            {title && (
              <h2 className="text-white text-lg sm:text-xl md:text-2xl font-bold text-center flex-1 mx-2 sm:mx-4 bg-gradient-to-r from-white to-gray-200 bg-clip-text text-transparent">{title}</h2>
            )}
            
            <button
              onClick={onClose}
              className="absolute top-2 right-2 sm:top-4 sm:right-4 flex items-center justify-center px-4 py-2 sm:px-6 sm:py-3 rounded-xl bg-gradient-to-br from-red-500/20 to-red-600/30 hover:from-red-500/30 hover:to-red-600/40 border border-red-400/40 hover:border-red-400/60 transition-all duration-200 group shadow-lg hover:shadow-red-500/20 min-w-[80px] sm:min-w-[100px]"
              aria-label="Bezárás"
              type="button"
              title="Bezárás"
            >
              <div className="flex items-center space-x-2">
                <svg className="w-4 h-4 text-red-300 group-hover:text-red-200 group-hover:scale-110 transition-all" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
                <span className="text-xs font-bold text-red-300 group-hover:text-red-200">BEZÁR</span>
              </div>
            </button>
          </div>
          <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent"></div>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto">
          <div className="p-6 sm:p-8 bg-gradient-to-b from-slate-800/20 to-transparent">
            <div className="max-w-none text-gray-100 leading-relaxed">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
